import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ApiClientService } from '../core/api-client.service';

@Component({
  standalone:true,
  selector:'app-microsoft-callback',
  template:`<main class="callback-shell"><section aria-live="polite"><h1>Microsoft / Outlook bağlantısı</h1><p>{{message()}}</p><a href="/app/settings.email-accounts">E-posta hesaplarına dön</a></section></main>`,
  styles:[`.callback-shell{min-height:100dvh;display:grid;place-items:center;padding:24px;box-sizing:border-box;background:var(--background,#f8f5ef);color:var(--text,#14211d)}section{width:min(100%,520px);text-align:center}h1{font-size:clamp(1.6rem,6vw,2.3rem)}p{line-height:1.6;overflow-wrap:anywhere}a{display:inline-block;margin-top:16px;padding:12px 20px;border-radius:12px;background:var(--accent,#2e978a);color:var(--accent-contrast,#fff);font-weight:700;text-decoration:none}`]
})
export class MicrosoftCallbackPage implements OnInit {
  private readonly route=inject(ActivatedRoute);
  private readonly api=inject(ApiClientService);
  protected readonly message=signal('Microsoft bağlantısı kontrol ediliyor…');
  ngOnInit(){if(typeof window!=='undefined')void this.complete();}
  private fail(message:string){this.message.set(message);if(window.opener&&!window.opener.closed)window.opener.postMessage({type:'microsoftConnectFailed',message},window.location.origin);}
  private async complete(){
    const params=this.route.snapshot.queryParamMap;
    const code=params.get('code')||'';
    const state=params.get('state')||'';
    const error=params.get('error')||'';
    window.history.replaceState(window.history.state,'',window.location.pathname);
    if(error){this.fail(error==='access_denied'?'Microsoft bağlantısına izin verilmedi. E-posta hesapları ekranından yeniden deneyebilirsiniz.':'Microsoft doğrulaması tamamlanamadı. E-posta hesapları ekranından yeniden deneyebilirsiniz.');return;}
    if(!code){this.message.set('Microsoft callback adresi hazır. Bağlantıyı e-posta hesapları ekranından başlatın.');return;}
    if(!state){this.fail('Microsoft bağlantı isteği doğrulanamadı. Bağlantıyı yeniden başlatın.');return;}
    try{
      const response:any=await firstValueFrom(this.api.post('/api/app/operation',{operationKey:'microsoft.oauth-callback',payload:{code,state}}));
      if(!response?.success&&!response?.result)throw new Error(response?.message||'Microsoft bağlantısı tamamlanamadı.');
      this.message.set('Microsoft hesabı bağlandı.');
      if(window.opener&&!window.opener.closed){window.opener.postMessage({type:'microsoftConnected'},window.location.origin);window.setTimeout(()=>window.close(),350);}
    }catch(error:any){this.fail(error?.error?.message||error?.message||'Microsoft bağlantısı tamamlanamadı.');}
  }
}
